<template>
  <footer class="bg-white pt-16">
    <div class="max-w-screen-3xl mx-auto px-4 sm:px-6 lg:px-8 2xl:px-22">
      <!-- Main Footer Content -->
      <div
        class="flex flex-col lg:flex-row lg:justify-between gap-12 lg:gap-8 items-start"
      >
        <!-- Left Section: Logo + Social -->
        <div class="flex flex-col gap-8 items-start">
          <!-- Logo -->
          <TaybaLogoFooter class="h-16 sm:h-20 w-auto" />

          <!-- Suivez-nous Section -->
          <UiSocialLinks
            containerClass="flex flex-col justify-start items-start gap-4"
            listClass="gap-5 flex items-center"
            linkClass="w-5 h-5 text-gray-700 hover:text-primary transition-colors"
            labelClass="text-xs font-bold text-gray-700 uppercase tracking-[0.48px] font-outfit"
          />
        </div>

        <!-- Right Section: Navigation Columns -->
        <!-- Footer Links Sections -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <!-- Nos Omras -->
          <div>
            <h3 class="text-gray-900 font-semibold mb-4">Nos Omras</h3>
            <ul class="space-y-2">
              <li>
                <NuxtLink
                  to="/omra"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Omra 2026
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/omra-ramadhan"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Omra Ramadhan
                </NuxtLink>
              </li>
            </ul>
          </div>

          <!-- Épargne -->
          <div>
            <h3 class="text-gray-900 font-semibold mb-4">Épargne</h3>
            <ul class="space-y-2">
              <li>
                <NuxtLink
                  to="/epargne/epargne-omra"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Éparge Omra
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/epargne/epargne-hajj"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Épargne Hajj
                </NuxtLink>
              </li>
            </ul>
          </div>

          <!-- Support -->
          <div>
            <h3 class="text-gray-900 font-semibold mb-4">Support</h3>
            <ul class="space-y-2">
              <li>
                <NuxtLink
                  to="/contact"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Contact
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/regles-de-sejour"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  Règles De Séjour
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/questions-frequentes"
                  class="text-gray-600 hover:text-[#d0a444] transition-colors"
                >
                  F.A.Q
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row-reverse justify-between pt-6 pb-4 md:pt-40 md:pb-6"
      >
        <!-- Bottom Links -->
        <div class="flex flex-wrap gap-4 mb-4 text-md md:text-lg">
          <NuxtLink
            to="/conditions-generales-d-utilisation"
            class="text-gray-600 hover:text-[#d0a444] transition-colors underline"
          >
            CGU
          </NuxtLink>
          <NuxtLink
            to="/conditions-generales-de-vente"
            class="text-gray-600 hover:text-[#d0a444] transition-colors underline"
          >
            CGV
          </NuxtLink>
          <NuxtLink
            to="/politique-de-confidentialite"
            class="text-gray-600 hover:text-[#d0a444] transition-colors underline"
          >
            RGPD
          </NuxtLink>
          <NuxtLink
            to="/politique-de-cookies"
            class="text-gray-600 hover:text-[#d0a444] transition-colors underline"
          >
            Politique De Cookies
          </NuxtLink>
        </div>
        <!-- Copyright -->
        <p class="text-md md:text-lg text-gray-600">
          © 2026 <span class="font-semibold">Tayba Travel</span>. Tous droits
          réservés.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import TaybaLogoFooter from "../ui/media/TaybaLogoFooter.vue";
</script>
